export default {
  DeptCateCode: "",
  Description: "",
  Active: true,
  UserModified: localStorage.getItem("UserName"),
};
